import axios from 'axios';

import IVendorEmailPayload from '../types/IVendorEmailPayload';

export const vendorBroadcast = (data: IVendorEmailPayload) =>
  axios.post('/vendorsearch/api/vendors/broadcast', data);
